import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import { Link } from 'react-router-dom';

const Place = ({ place: { placeName, img, id,shortDescription } }) => {
    const useStyles = makeStyles({
        root: {
            maxWidth: 300,
        },
    });

    const classes = useStyles();

    return (
        <div className="m-3 p-2 text-center text-capitalize">
            <Card className={classes.root}>
                <CardMedia
                    component="img"
                    height="340"
                    image={img}
                />
                <CardContent>
                <Typography gutterBottom variant="" component="" className="font-weight-normal">
                        {shortDescription}
                    </Typography>
                    <Typography gutterBottom variant="h5" component="h2" className="font-weight-bold">
                        {placeName}
                    </Typography>
                </CardContent>
                <Link className="btn btn-warning mb-3 w-4" to={`/booking/${id}`}>Booking</Link>
            </Card>
        </div >
    );
};

export default Place;